module.exports = __webpack_public_path__ + "img/id.ef9ba59e.jpg";